/**
 * El ultimo valor que llego para una misma `base`, mientras llega el siguiente.
 *
 * Al cambiar un filtro, el listado vuelve a cargar y sus datos pasan a nulo.
 * Sin esto la barra de filtros —y en una categoria, el titulo— desaparecerian y
 * volverian en cada clic, y con ellos el lugar donde se estaba mirando. Cambiar
 * de `base` (otro termino, otra categoria) si olvida lo anterior.
 *
 * `valor` tiene que conservar su identidad entre renders mientras no cambie.
 */
import { useState } from 'react';

export function useUltimoDe<T>(base: string, valor: T | null): T | null {
  const [guardado, setGuardado] = useState<{ base: string; valor: T } | null>(null);

  if (valor !== null && (guardado?.base !== base || guardado.valor !== valor)) {
    setGuardado({ base, valor });
  }

  if (valor !== null) return valor;
  return guardado?.base === base ? guardado.valor : null;
}
